'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext, useEffect } from 'react';
import '@digdir/designsystemet-web';
import { SuggestionContext } from './suggestion.js';

/**
 * Component that provides a Suggestion list.
 *
 * Place as a descendant of `Suggestion`
 *
 * @example
 * <Suggestion>
 *   <Suggestion.Input />
 *   <Suggestion.List />
 * </Suggestion>
 */
const SuggestionList = forwardRef(function SuggestionList({ singular = '%d forslag', plural = '%d forslag', className, id, autoPlacement = true, ...rest }, ref) {
    const { handleFilter } = useContext(SuggestionContext);
    useEffect(handleFilter); // Must run on every render
    return (jsx("u-datalist", { class: className, popover: 'manual' // Is also set by field.ts, but is nice to have in case focus runs before toggle event
        , "data-nofilter": true, "data-sr-plural": plural, "data-sr-singular": singular, ref: ref, suppressHydrationWarning // Since <u-datalist> adds attributes
        : true, ...rest }));
});

export { SuggestionList };
